import { render, staticRenderFns } from "./MortgagesHeader.vue?vue&type=template&id=eb6c59d2&"
import script from "./MortgagesHeader.vue?vue&type=script&lang=ts&"
export * from "./MortgagesHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports